<div class="window-footer">
  <ng-container *ngIf="!(showCompletedButtons$ | async); else completed_container">
    <app-tertiary-button
      *ngIf="(slidingWindowOptions$ | async)?.secondaryButtonText"
      (buttonClicked)="secondaryButtonClicked.emit()">
      {{ (slidingWindowOptions$ | async)?.secondaryButtonText }}
    </app-tertiary-button>
    <app-primary-button
      *ngIf="(slidingWindowOptions$ | async)?.primaryButtonText && !(hideActionButton$ | async)"
      (buttonClicked)="primaryButtonClicked.emit()">
      {{ (slidingWindowOptions$ | async)?.primaryButtonText }}
    </app-primary-button>
  </ng-container>
</div>

<ng-template #completed_container>
  <div class="completed-container">
    <app-tertiary-button
      *ngIf="(slidingWindowOptions$ | async)?.secondaryButtonText"
      (buttonClicked)="secondaryButtonClicked.emit()">
      {{ (slidingWindowOptions$ | async)?.secondaryButtonText }}
    </app-tertiary-button>
    <app-primary-button (buttonClicked)="secondaryButtonClicked.emit()">
      {{ (slidingWindowOptions$ | async)?.completedStateText }}
    </app-primary-button>
  </div>
</ng-template>
